module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "4fr 1fr",
      "gap": "1rem",
      "align-items": "start"
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('modal-wr')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n              Nuevo paquete\n            ")])]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_c('div', {
    staticClass: "u-row-wr u-row--header"
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Producto")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Warehouse")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Acciones")])]), _vm._v(" "), _vm._l((_vm.warehouseorder), function(data) {
    return _c('div', {
      key: data,
      staticClass: "u-row-wr"
    }, [_c('div', [(!_vm.isOrder) ? _c('button', {
      staticClass: "btn-paquete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openModal('modal-orden')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus"
    }), _vm._v(" "), _c('span', [_vm._v("Asociar orden")])]) : _c('article', {
      staticClass: "card-product"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "card-product__img",
      attrs: {
        "src": "https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8c2hvZXMlMjBuaWtlfGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("Nike shoes")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Nombres:")]), _vm._v("\n                        Jesus Gallardo\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código del cliente:")]), _vm._v("\n                        #123456789\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                        #12345\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje desde:")]), _vm._v("\n                        Miami, Estados Unidos\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje a:")]), _vm._v("\n                        Lima, Perú\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Número de orden:")]), _vm._v("\n                        #12345\n                      ")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "max-width": "30vw"
      }
    }, [(!_vm.isWr) ? _c('button', {
      staticClass: "btn-paquete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openModal('modal-wr')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus"
    }), _vm._v(" "), _c('span', [_vm._v("Nuevo paquete")])]) : [_c('vue-glide', {
      attrs: {
        "perView": 2
      }
    }, [_c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('template', {
      slot: "control"
    }, [_c('button', {
      staticClass: "slider__btn slider__btn--prev",
      attrs: {
        "data-glide-dir": "<"
      }
    }, [_c('i', {
      staticClass: "fas fa-arrow-left"
    })]), _vm._v(" "), _c('button', {
      staticClass: "slider__btn slider__btn--next",
      attrs: {
        "data-glide-dir": ">"
      }
    }, [_c('i', {
      staticClass: "fas fa-arrow-right"
    })])])], 2)]], 2), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary mb-3 d-block mx-auto",
      attrs: {
        "disabled": data.attributes.warehouse_flag == 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-wr', data.id)
        }
      }
    }, [_vm._v("\n                  Registrar ingreso\n                ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary d-block mx-auto",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.limitchangePaquete(data.id)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(data.attributes.warehouse_flag == 0 ?
      "Items incompletos" :
      "Items completos") + "\n                ")])])])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wr-slider-vertical"
  }, [_c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])]), _vm._v(" "), _c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])]), _vm._v(" "), _c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])]), _vm._v(" "), _c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])])])]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrders
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-wr"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Datos del paquete")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-wr')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Consignatario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.consignee),
      expression: "formCreate.consignee"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Carrier ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.carrier),
      expression: "formCreate.carrier"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "carrier", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Tracking ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.tracking),
      expression: "formCreate.tracking"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.tracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "tracking", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Peso")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.weight),
      expression: "formCreate.weight"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Unidad de peso:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unidad),
      expression: "formCreate.unidad"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "unidad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 12
    }
  }, [_vm._v("Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 22
    }
  }, [_vm._v("Oz")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comentario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.comment),
      expression: "formCreate.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fotos del paquete")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": "",
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar ingreso\n        ")])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-orden"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    staticStyle: {
      "max-width": "95vw",
      "max-height": "80vh"
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Asociar orden")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-orden')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n                      " + _vm._s(option.label) + "\n                    ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getPurchaseOrdersByPage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect form-control",
    attrs: {
      "id": "checkboxes2"
    }
  }, [_c('div', {
    staticClass: "selectBox",
    on: {
      "click": _vm.showCheckboxes
    }
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "overSelect"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "checkboxes"
    }
  }, [_c('label', {
    staticClass: "check-filter",
    attrs: {
      "for": "one"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.statusFlag.todos),
      expression: "tableData.statusFlag.todos"
    }],
    staticClass: "checkbox-style box-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tableData.statusFlag.todos) ? _vm._i(_vm.tableData.statusFlag.todos, null) > -1 : (_vm.tableData.statusFlag.todos)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.tableData.statusFlag.todos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tableData.statusFlag, "todos", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tableData.statusFlag, "todos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tableData.statusFlag, "todos", $$c)
        }
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v("Todos\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "check-filter",
    attrs: {
      "for": "two"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.statusFlag.activos),
      expression: "tableData.statusFlag.activos"
    }],
    staticClass: "checkbox-style box-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tableData.statusFlag.activos) ? _vm._i(_vm.tableData.statusFlag.activos, null) > -1 : (_vm.tableData.statusFlag.activos)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.tableData.statusFlag.activos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tableData.statusFlag, "activos", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tableData.statusFlag, "activos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tableData.statusFlag, "activos", $$c)
        }
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v("Activos\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "check-filter",
    attrs: {
      "for": "three"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.statusFlag.cancelados),
      expression: "tableData.statusFlag.cancelados"
    }],
    staticClass: "checkbox-style box-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tableData.statusFlag.cancelados) ? _vm._i(_vm.tableData.statusFlag.cancelados, null) > -1 : (_vm.tableData.statusFlag.cancelados)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.tableData.statusFlag.cancelados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tableData.statusFlag, "cancelados", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tableData.statusFlag, "cancelados", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tableData.statusFlag, "cancelados", $$c)
        }
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v("Cancelados\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bloc filter-block-alone"
  }, [_c('label', [_vm._v("Tipo de orden:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "store", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all",
      "selected": ""
    }
  }, [_vm._v("Todo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sendi",
      "data-content": "<span class='badge badge-info'>Ofertas de Grabr</span>"
    }
  }, [_vm._v("\n                    Sendi\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enviosusa",
      "data-content": "<span class='badge badge-warning'>Ofertas no Grabr</span>"
    }
  }, [_vm._v("\n                    Envios Usa\n                  ")])])])]), _vm._v(" "), (_vm.tableData.order_type === 4) ? _c('div', {
    staticClass: "filter-bloc"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('form', {
    staticClass: "formulario",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [(this.valorRadioButton == true) ? _c('span', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inicio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inicio"
    }
  }, [_vm._v("Todo")])]) : (this.valorRadioButton == false) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "todo"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.tableData.store, null)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", null)
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "todo"
    }
  }, [_vm._v("Todo")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "electro"
    },
    domProps: {
      "value": 'electro',
      "checked": _vm._q(_vm.tableData.store, 'electro')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'electro')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "electro"
    }
  }, [_vm._v("Electro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "fashion"
    },
    domProps: {
      "value": 'fashion',
      "checked": _vm._q(_vm.tableData.store, 'fashion')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'fashion')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fashion"
    }
  }, [_vm._v("Fashion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "kids"
    },
    domProps: {
      "value": 'kids',
      "checked": _vm._q(_vm.tableData.store, 'kids')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'kids')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kids"
    }
  }, [_vm._v("Kids")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "home"
    },
    domProps: {
      "value": 'home',
      "checked": _vm._q(_vm.tableData.store, 'home')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'home')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "home"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "pets"
    },
    domProps: {
      "value": 'pets',
      "checked": _vm._q(_vm.tableData.store, 'pets')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'pets')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pets"
    }
  }, [_vm._v("Pets")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.purchaseOrders != null && _vm.purchaseOrders.length > 0) ? _c('tbody', _vm._l((_vm.diasRestantes), function(purchaseOrder) {
    return _c('router-link', {
      key: purchaseOrder.id,
      attrs: {
        "to": {
          name: 'show-purchase-order',
          params: {
            id: purchaseOrder.id,
            orderData: purchaseOrder
          },
        }
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "image-table"
    }, [(
      purchaseOrder.attributes.product_image_url == null &&
      purchaseOrder.attributes.is_from_meli_flag
    ) ? _c('img', {
      attrs: {
        "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png',
        "width": "180px",
        "height": "260px"
      }
    }) : (
      purchaseOrder.attributes.product_image_url == null &&
      purchaseOrder.attributes.is_from_linio_flag
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/linio-logo.png",
        "width": "180px",
        "height": "260px"
      }
    }) : (purchaseOrder.attributes.product_image_url) ? _c('img', {
      attrs: {
        "src": purchaseOrder.attributes.product_image_url,
        "width": "180px",
        "height": "260px"
      }
    }) : _c('img', {
      attrs: {
        "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png',
        "width": "180px",
        "height": "260px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "description-title"
    }, [_c('span', {
      staticClass: "description-title-principal"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.product_info))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "code-order system-code"
    }, [_vm._v("SB #" + _vm._s(purchaseOrder.id) + "\n                          ")]), _vm._v(" "), (purchaseOrder.attributes.is_from_linio_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                            #" + _vm._s(purchaseOrder.attributes.linioOrder.attributes.linio_order_id))]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                            #" + _vm._s(purchaseOrder.attributes.meliOrder.attributes.meli_order_id))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: purchaseOrder.attributes.status == 10 ?
        'bg-danger' :
        'bg-success'
    }, [_vm._v("\n                            " + _vm._s(purchaseOrder.attributes.status == 10 ? "Cancelada" : "Activa") + "\n                          ")]), _vm._v(" "), (purchaseOrder.attributes.type === 2) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.reference_link) ? _c('span', {
      staticClass: "badge badge-primary bg-primary"
    }, [_vm._v(_vm._s(_vm.getStore(purchaseOrder.attributes.reference_link)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary bg-secondary"
    }, [_vm._v("WR -" + _vm._s(purchaseOrder.attributes.warehouse_admin))])]), _vm._v(" "), (purchaseOrder.attributes.is_from_grabr_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-grabr"
    }, [_vm._v("Grabr")]), _vm._v(" "), _c('span', {
      staticClass: "code-order grabr-code",
      on: {
        "click": function($event) {
          return _vm.toGrabrDetail(
            purchaseOrder.attributes.grabrOrder.attributes
            .grabr_order_number
          )
        }
      }
    }, [_vm._v(_vm._s(purchaseOrder.attributes.grabrOrder.attributes
      .grabr_order_number))])]) : (purchaseOrder.attributes.is_from_linio_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-linio"
    }, [_vm._v("Linio")])]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-meli"
    }, [_vm._v("Mercado libre")]), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'electro'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-primary"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'kids'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store magenta"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'fashion'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store brown"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'home'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('span', {}, [_vm._v(_vm._s(purchaseOrder.attributes.product_specimens))])]), _vm._v(" "), (
      purchaseOrder.attributes.origin != undefined &&
      purchaseOrder.attributes.destination != undefined
    ) ? _c('td', [_c('div', {
      staticClass: "ruta-order-container"
    }, [_c('div', {
      staticClass: "ruta-order-block ruta-order-image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/ruta.svg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-block"
    }, [_c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.origin.attributes.name))])]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.destination_address))])])])])]) : _c('td', [_c('span', {
      staticClass: "ruta-order"
    }, [_vm._v("No se ha definido")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "order-tag-container"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-pago-status.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (purchaseOrder.attributes.payed === 1) ? _c('span', [_vm._v("PENDIENTE")]) : (purchaseOrder.attributes.payed === 2) ? _c('span', [_vm._v("EN PROCESO")]) : (purchaseOrder.attributes.payed === 3) ? _c('span', [_vm._v("CONFIRMADO")]) : (purchaseOrder.attributes.payed === 10) ? _c('span', [_vm._v("RECHAZADO\"")]) : (purchaseOrder.attributes.payed === 11) ? _c('span', [_vm._v("RECLAMADO")]) : (purchaseOrder.attributes.payed === 12) ? _c('span', [_vm._v("RETORNADO")]) : _vm._e()]), _vm._v(" "), _c('span', [_c('ul', [_c('li', [_c('span', [(purchaseOrder.attributes.payment_method_flag === 5) ? _c('span', [(purchaseOrder.attributes.payment_code === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.payment_code !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 2) ? _c('span', [(
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 3) ? _c('span', [(
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 4) ? _c('span', [(
      purchaseOrder.attributes.atm_payment.mp_payment_id ===
      null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.atm_payment.mp_payment_id !==
      null && purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 6) ? _c('span', [_vm._v("Pago con saldo")]) : _vm._e(), _vm._v("\n                                - Código")])]), _vm._v(" "), _c('li', [(purchaseOrder.attributes.voucher_link === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.voucher_link !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-3.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-2.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e(), _vm._v("\n                              - Voucher\n                            ")])])]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-tracking-statu.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 1
    ) ? _c('span', [_vm._v("\n                            EN REVISIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 2
    ) ? _c('span', [_vm._v("\n                            COMPRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 3
    ) ? _c('span', [_vm._v("\n                            PREPARANDO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 4
    ) ? _c('span', [_vm._v("\n                            LISTO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 5
    ) ? _c('span', [_vm._v("\n                            ENVIADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 6
    ) ? _c('span', [_vm._v("\n                            LISTO PARA ENTREGAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 7
    ) ? _c('span', [_vm._v("\n                            ENTREGADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 8
    ) ? _c('span', [_vm._v("\n                            SINIESTRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 9
    ) ? _c('span', [_vm._v("\n                            EN PROCESO DE DEVOLUCIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 10
    ) ? _c('span', [_vm._v("\n                            RETORNADO AL PROVEEDOR")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_c('span', {}, [(purchaseOrder.attributes.vouchers_usa.length !== 0) ? _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-1.svg",
        "width": "50",
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-2.svg",
        "width": "50",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('td', [_c('span', {}, [_vm._v(_vm._s(purchaseOrder.attributes.order_create_date))])]), _vm._v(" "), (purchaseOrder.attributes.hasOwnProperty('promised_delivery_date')) ? _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDate")(purchaseOrder.attributes.promised_delivery_date)))]), _vm._v(" "), _c('div', {
      staticClass: "daysLeft"
    }, [(purchaseOrder.resultado > 15) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.resultado) + " días")]) : _vm._e(), _vm._v(" "), (purchaseOrder.resultado > 10 && purchaseOrder.resultado <= 15) ? _c('span', {
      staticClass: "badge badge-primary bg-warning"
    }, [_vm._v("\n                          " + _vm._s(purchaseOrder.resultado) + " días\n                        ")]) : _vm._e(), _vm._v(" "), (purchaseOrder.resultado <= 10) ? _c('span', {
      staticClass: "badge badge-primary bg-danger"
    }, [(Math.sign(purchaseOrder.resultado) === 1) ? _c('span', [_vm._v(_vm._s(purchaseOrder.resultado) + " días\n                          ")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === -1) ? _c('span', [_vm._v("\n                            Retraso de\n                            " + _vm._s(Math.abs(purchaseOrder.resultado)) + " dias")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === 0) ? _c('span', [_vm._v("\n                            Retraso")]) : _vm._e()]) : _vm._e()])]) : _c('td', [_c('span', {}, [_vm._v("No definido")])])])])
  }), 1) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-fotos"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    staticStyle: {
      "max-width": "70vw",
      "width": "70vw"
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Fotos del producto")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-fotos')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _vm._m(33)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Warehouse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {}, [_c('label', [_vm._v("Buscar por:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between col-6 px-0",
    staticStyle: {
      "gap": ".75rem"
    }
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("Nombre de orden")]), _vm._v(" "), _c('option', [_vm._v("Número de orden")]), _vm._v(" "), _c('option', [_vm._v("Número de WR")])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("\n                Buscar\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remitente")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Órdenes de compra")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "kt-form__label"
  }, [_c('option', [_vm._v("Seleccionar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "1fr 1fr 1fr",
      "gap": "1rem"
    }
  }, [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172f89f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WarehouseTable2.vue
// module id = 1854
// module chunks = 1